var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "中文名称",
                            prop: "nameCn",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写中文名称" },
                            model: {
                              value: _vm.inputForm.nameCn,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "nameCn", $$v)
                              },
                              expression: "inputForm.nameCn",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "套餐项目id",
                            prop: "positionProjectId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写套餐项目id" },
                            model: {
                              value: _vm.inputForm.positionProjectId,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.inputForm,
                                  "positionProjectId",
                                  $$v
                                )
                              },
                              expression: "inputForm.positionProjectId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "单价", prop: "price", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写单价" },
                            model: {
                              value: _vm.inputForm.price,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "price", $$v)
                              },
                              expression: "inputForm.price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "材料-计价最低用量",
                            prop: "minUsage",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写材料-计价最低用量" },
                            model: {
                              value: _vm.inputForm.minUsage,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "minUsage", $$v)
                              },
                              expression: "inputForm.minUsage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "损耗率",
                            prop: "rateNum",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写损耗率" },
                            model: {
                              value: _vm.inputForm.rateNum,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "rateNum", $$v)
                              },
                              expression: "inputForm.rateNum",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "损耗率描述",
                            prop: "rateDesc",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写损耗率描述" },
                            model: {
                              value: _vm.inputForm.rateDesc,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "rateDesc", $$v)
                              },
                              expression: "inputForm.rateDesc",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "材料方案id",
                            prop: "makeupId",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写材料方案id" },
                            model: {
                              value: _vm.inputForm.makeupId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "makeupId", $$v)
                              },
                              expression: "inputForm.makeupId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "材料id", prop: "itemId", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写材料id" },
                            model: {
                              value: _vm.inputForm.itemId,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "itemId", $$v)
                              },
                              expression: "inputForm.itemId",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "材料类型(主/辅)",
                            prop: "mateKind",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写材料类型(主/辅)" },
                            model: {
                              value: _vm.inputForm.mateKind,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "mateKind", $$v)
                              },
                              expression: "inputForm.mateKind",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }